// IconActionButton.tsx
import React from 'react';
import '../css/iconActionButton.css';

export interface IconActionButtonProps {
  icon: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  ariaLabel?: string;
  title?: string;
  className?: string;
}

const IconActionButton: React.FC<IconActionButtonProps> = ({
  icon,
  onClick,
  disabled = false,
  ariaLabel,
  title,
  className = '',
}) => {
  return (
    <button
      type="button"
      className={`scl--cms-components-iconActionButton ${className} ${disabled ? 'scl--cms-components-iconActionButton--disabled' : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      title={title}
    >
      <span className="scl--cms-components-iconActionButton__icon">
        {icon}
      </span>
    </button>
  );
};

export default IconActionButton;